// Atomspire Tactical Areas — 10 Areas (I through X)
// Hybrid theme: each area gets a tint color used for thumbnail strip + preview accents
export const detailedMapAreas = [
  {
    id: 1,
    code: 'AREA I',
    name: 'Laboratory & Research Centre',
    description: 'Advanced scientific facility with high-tech equipment and experimental zones.',
    risk: 'High',
    threat: 'Elite synthoids, plasma barriers, flux turrets.',
    loot: 'Rare syringes, plasma batteries, key cards',
    features: ['Terraform Device', 'High-value loot crates', 'NPC Scientists'],
    tint: '#7BB6A0',
    markerX: 17,
    markerY: 24,
  },
  {
    id: 2,
    code: 'AREA II',
    name: 'Aerospace Hangar',
    description: 'Massive hangar complex with spacecraft and advanced flight technology.',
    risk: 'Medium',
    threat: 'Armed patrols, automated turrets, drones.',
    loot: 'Energy weapons, jetpacks, armor upgrades',
    features: ['Vehicle spawns', 'Elevated positions', 'Multi-entry points'],
    tint: '#9CB7CF',
    markerX: 14,
    markerY: 55,
  },
  {
    id: 3,
    code: 'AREA III',
    name: 'Enforcement Grid',
    description: 'Military compound bristling with defense systems and weapon caches.',
    risk: 'Critical',
    threat: 'Heavy mechs, missile grids, fortified squads.',
    loot: 'Heavy weapons, combat armor, missile strikes',
    features: ['Terraform Device', 'Scout robots', 'Defensive positions'],
    tint: '#C97A6A',
    markerX: 71,
    markerY: 35,
  },
  {
    id: 4,
    code: 'AREA IV',
    name: 'Elemental Extraction',
    description: 'Mining facility extracting elemental gases from deep underground veins.',
    risk: 'High',
    threat: 'Elite synthoids, plasma barriers, flux turrets.',
    loot: 'Element capsules, plasma reactors, rare materials',
    features: ['Terraform Device', 'Environmental hazards', 'Vertical gameplay'],
    tint: '#D9B26A',
    markerX: 79,
    markerY: 18,
  },
  {
    id: 5,
    code: 'AREA V',
    name: 'Techspire',
    description: 'Towering technology hub piercing through the toxic upper atmosphere.',
    risk: 'Medium',
    threat: 'Armed patrols, automated turrets, drones.',
    loot: 'Tech upgrades, energy shields, advanced scopes',
    features: ['Sniper positions', 'Ziplines', 'Multi-level combat'],
    tint: '#A492C9',
    markerX: 44,
    markerY: 42,
  },
  {
    id: 6,
    code: 'AREA VI',
    name: 'Horizon Medisphere',
    description: 'Medical complex with healing supplies, syringes, and research labs.',
    risk: 'Medium',
    threat: 'Armed patrols, automated turrets, drones.',
    loot: 'Syringes, medkits, disinfection items',
    features: ['Safe zones', 'Healing stations', 'NPC medics'],
    tint: '#7DC2B0',
    markerX: 49,
    markerY: 81,
  },
  {
    id: 7,
    code: 'AREA VII',
    name: 'Bio Farms',
    description: 'Agricultural domes growing resources in controlled bio-environments.',
    risk: 'Low',
    threat: 'Light scavengers, minimal automated defenses.',
    loot: 'Organic materials, basic supplies, food items',
    features: ['Open fields', 'Cover positions', 'Resource gathering'],
    tint: '#B5C97A',
    markerX: 32,
    markerY: 79,
  },
  {
    id: 8,
    code: 'AREA VIII',
    name: 'Eco Dome Haven',
    description: 'Protected biodome with native flora, dense canopy, and clean air.',
    risk: 'Medium',
    threat: 'Armed patrols, automated turrets, drones.',
    loot: 'Rare plants, crafting materials, key cards',
    features: ['Dense vegetation', 'Stealth gameplay', 'Hidden paths'],
    tint: '#82C97A',
    markerX: 66,
    markerY: 68,
  },
  {
    id: 9,
    code: 'AREA IX',
    name: 'Port / Harbor',
    description: 'Massive shipping facility lined with cargo containers and transport ships.',
    risk: 'High',
    threat: 'Elite synthoids, plasma barriers, flux turrets.',
    loot: 'Assorted weapons, armor, vehicle parts',
    features: ['Terraform Device', 'CQB combat', 'Container maze'],
    tint: '#6FA4D6',
    markerX: 90,
    markerY: 76,
  },
  {
    id: 10,
    code: 'AREA X',
    name: 'Restricted Zone',
    description: 'Classified military sector with unknown experiments and extreme danger.',
    risk: 'Extreme',
    threat: 'Infected swarms, arc reactors, lethal hazards.',
    loot: 'Legendary weapons, Cycle 3 key cards, arc reactors',
    features: ['Infected area', 'Boss encounters', 'Maximum rewards'],
    tint: '#D24A4A',
    markerX: 38,
    markerY: 22,
  },
];

export const mapZones = [
  { id: 'atomspire', name: 'ATOMSPIRE', sub: 'SECTOR 01', available: true, theme: 'Nuclear energy and radiation' },
  { id: 'stellar-reach', name: 'STELLAR REACH', sub: '2316', available: false, theme: 'Industrial steam power' },
  { id: 'aurelis-rift', name: 'AURELIS RIFT', sub: '2318', available: false, theme: 'Deep ocean trenches' },
  { id: 'nexus-gate', name: 'NEXUS GATE', sub: '2324', available: false, theme: 'Volcanic battlegrounds' },
  { id: 'zenith-blade', name: 'ZENITH BLADE', sub: '2340', available: false, theme: 'Solar-scorched deserts' },
];
